import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../services/maintenanceService';
import { NgClass } from '@angular/common';
import { DigitFormatterPipe } from '../../../../shared/pipe/digit-formatter.pipe';

@Component({
    selector: 'app-forecast-detail-card',
    templateUrl: './forecast-detail-card.component.html',
    styleUrls: ['./forecast-detail-card.component.css'],
    imports: [NgClass, DigitFormatterPipe]
})
export class ForecastDetailsCardComponent implements OnInit {
  @Input() forecastDetailsMap: Map<string, any>;
  public dataLoaded = false;
  constructor(
    public maintenanceService: MaintenanceService,
    public toaster: ToastrService,
  ) {}

  ngOnInit() {
    this.dataLoaded = true;
  }

  getABSValue(value){
    return Math.abs(value);
  }

  searchTableData(searchValue: string): boolean {
    if (!this.forecastDetailsMap) {
      return false;
    }
    for (const value of this.forecastDetailsMap.values()) {
      if (value === searchValue) {
        return true;
      }
    }
    return false;
  }
}
